import type { PropsWithChildren } from 'react';
import Styles from './RadioGroup.module.scss';
export interface RadioGroupProps {
    id: string;
    name: string;
}
function RadioGroup({ children, id, name }: PropsWithChildren<RadioGroupProps>): React.ReactElement {
    return (
        <div className={Styles.radioGroup}>
            <label className={Styles.title}>{name}</label>
            <fieldset className={Styles.radios} id={id}>
                {children}
            </fieldset>
        </div>
    );
}

export default RadioGroup;
